module.exports = __webpack_public_path__ + "static/media/03_01_08.1f4538b5.png";